"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicKeyTrustStatus = void 0;
var PublicKeyTrustStatus;
(function (PublicKeyTrustStatus) {
    PublicKeyTrustStatus["Trusted"] = "Trusted";
    PublicKeyTrustStatus["Previous"] = "Previous";
    PublicKeyTrustStatus["NotTrusted"] = "NotTrusted";
})(PublicKeyTrustStatus || (exports.PublicKeyTrustStatus = PublicKeyTrustStatus = {}));
